export default __webpack_public_path__ + "static/media/EBGaramond-Bold.ab3ca972.ttf";